export const translations = {
  en: {

    //common
    areYouSureYouWantToSubmitThisForm:"Are you sure you want to submit this form?",
    yes:"Yes",
    nono:"No",
    confirm:"Confirm",

    dashboard: 'Dashboard',
    unpaidList: 'Unpaid List',
    language: 'Language',
    account: 'Account',
    logout: 'Log out',
    changePassword: 'Change Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    username: 'User Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    submit: 'Submit',
    ServiceFee: 'Service Fee ',

    //overView
    allAssociation: 'All Association',
    allMembers: "All Members",
    thisMonth: "This Month",
    thisMonthAndPassed: "Total Unpaid Amount Until Today ",
    totalPaid: "Total Paid",
    totalUnpaid: "Total Unpaid",
    totalPaid: "Total Paid",
    total:"Total",
    unpaid:"Unpaid",
    paid:"Paid",
    satistics:"Satistics",
    thisYearRevenue:"This Year Revenue",
    jan:"Jan",
    feb:"Feb",
    mar:"Mar",
    apr:"Apr",
    may:"May",
    jun:"Jun",
    jul:"Jul",
    aug:"Aug",
    sep:"Sep",
    oct:"Oct",
    nov:"Nov",
    dec:"Dec",

    //users
    no:"No.",
    newUsers:"New Users",
    lockUser:"Lock User",
    unlockUser:"Unlock User",
    editUser:"Edit User",
    usersPermissions:"Users Permissions",
    addModule:"Add Module",
    module:"Module",	
    view:"View",	
    create:"Create",	
    update:"Update",	
    delete:"Delete",	
    addPermission:"Add Permission",
    createdAt:"Created At",
    addUsers:"Add Users",
    role:"Role", 
    recordsPerPage:"records per page",
    manager:"Manager",finance:"Finance",user:"User", admin:"Admin",
    selectTheAssociation:"Select The Association",
    accountNumber:"Account Number",

    //Association
    newAssociation:"New Association",
    addAssociation:"Add Association",
    addBulkData:"Add Bulk Data",
    associationName:"Association Name",
    associationType:"Association Type",	
    associationAmount:"Association Amount",	
    numberOfMembers:"Number Of Members",	
    startDate:"Start Date",	
    endDate:"End Date",	
    cycle:"cycle",	
    createdAt:"Created At",	
    createdBy:"Created By",	
    description:"Description",
    downloadSampleFile:"Download Sample File",
    uploadExcelFile:"Upload Excel File",
    browse:"Browse",
    editAssociation:"Edit Association",
    associationOption:"Association",
    individual:"Individual",
    associationId:"Association Id",
    adminUserName:"Admin User",

    Yearly:"Yearly",
    Monthly:"Monthly",
    Weakly:"Weakly",
    Daily:"Daily",

    //members
    newMember:"New Member",
    addMember:"Add Member",
    fullName:"Full Name",
    email:"Email",
    sex:"Sex",
    phoneNumber:"Phone Number",
    address:"Address",
    job:"Job",
    idNumber:"ID Number",
    memberName:"	Member Name",
    editMember:"Edit Member",
    associationLinkageDescription:"Association Linkage Description",
    memberDescription:"Members Description",
    male:"Male",
    female:"Female",

    Five:"Five",
    Four:"Four",
    Three:"Three",
    Two:"Two",
    One:"One",

    //Linking Association
    linkingAssociation:"Linking Association",
    associationTypeInfo:"Association Type Info",
    associationMember:"Association Member",
    associationLinkage:"Association Linkage",
    summary:"Summary",
    existingAssociationType:"Existing Association Type",
    associationType:"Association Type",
    associationName:"Association Name",
    associationType:"Association Type",
    associationAmount:"Association Amount",
    cycle:"Cycle",
    numberOfEkuber:"Number Of Ekuber",
    existingAssociationMember:"Existing Association Member",
    associationMember:"Association Member",
    numberOfShare:"Number of Contribution by the Member",
    totalAmount:"Total Amount",
    attachedDocument:"Attached Document",
    prev:"Prev",
    next:"Next",
    editLinkage:"Edit Linkage",
    amount:"Amount",
    uniqueId:"Unique ID",
    nextPaymentDate:"Last Payment/Payment Until",
    paymentStatus:"Payment Status",
    numberOfAssociationMembers:"Number Of Association Members",
    linkageInformation:"Linkage Information",
    attachedFile:"Attached file",
    nothingFound:"Nothing found",

    //Payment
    dateFrom:"Date From",
    dateTo:"Date To",
    member:"Member",
    memberPhoneNo:"Member Phone No",
    paidAmount:"Paid Amount",
    paidFor:"Paid for this month",
    paidTypeFor:"Transaction Type",
    paymentMethod:"Payment Method",
    dateOfPayment:"Date of Payment",
    creditAccount:"Credit Account",
    transactionReference:"Transaction Reference",
    noDateSelected:"No date selected",
    find:"Find",
    status: "Status",
    
    //Report
    association:"Association",
    paymentStatusForThisMonth:"Payment Status for This Month",
    completionStatus:"Completion Status",
    contributionAmount:"Contribution Amount",
    Drawn:"Drawn?",
    totalMember:"Total Member",
    totalCollectedAmount:"Total Collected Amount (ETB)",
    totalServiceFee:"Total Service Fee (ETB)",
    totalCollectedPayment:"Total Collected Amount (ETB)",
    totalCollectedFeePayment:"Total Collected Fee Amount (ETB)",
    memberPhone:"Member Phone",
    savingStartDate:"Equb Start Date",
    exportToPdf:"Export to Pdf",
    exportToExcel:"Export to excel",
    paymentId:"Payment Id",

    //Draw
    selectDrawFor:"Select Draw For",
    numberOfEkub:"Number Of Giving Chance",
    selectAssociationType: "Select Association Type",
    Spinning: "Spin/Assign",
    takerName:"Winner Name",
    nameOfAssociation:"Association Name",
    selectWinnerType: "Select Winner Type",
    associations:"Associations",
    individuals:"Individuals",
    all:"All",
    selectMethod:"Select Method",
    spin:"Spin",
    manual:"Assign",
    forAssociation:"Association",
    spinOrAssignFor:"Action For",
    selectAssociation:"Select Association",
    name:"Name",
    uniqueId:"Unique Id",
    nameOrUniqueId:"Name/UniqueId",
    enterTheAmount:"Enter The Amount",
    giveEqub:"Give Equb",

    users: "Users",
    association: "Association",
    members: "Members",
    associationLinkage: "Association Linkage",
    drawingChance: "Drawing Chance",
    paymentsHistory: "Payments History",
    report: "Report"
  },
  am: {
    //common
    areYouSureYouWantToSubmitThisForm: "እርግጠኛ ነዎት ይህን ቅጽ ማስገባት ይፈልጋሉ?",
    yes: "አዎ",
    nono: "አይ",
    confirm: "አረጋግጥ",

    dashboard: 'ዳሽቦርድ',
    unpaidList: 'ያልተከፈሉ ዝርዝር',
    language: 'ቋንቋ',
    account: 'መለያ',
    logout: 'ውጣ',
    changePassword: 'የይለፍ ቃል ቀይር',
    firstName: 'ስም',
    lastName: 'የአባት ስም',
    username: 'የተጠቃሚ ስም',
    phoneNumber: 'ስልክ ቁጥር',
    email: 'ኢሜል',
    oldPassword: 'የቀድሞ የይለፍ ቃል',
    newPassword: 'አዲስ የይለፍ ቃል',
    confirmPassword: 'የይለፍ ቃልን አረጋግጥ',
    submit: 'አስገባ',
    ServiceFee: 'የአገልግሎት ክፍያ ',

        //overView
    allAssociation: 'ሁሉም ማህበር',
    allMembers: "ሁሉም አባላት",
    thisMonth: "ለዚህ ወር",
    thisMonthAndPassed: "እስከ ዛሬ ጠቅላላ ያልተከፈለ ክፍያ ",
    total:"ጠቅላላ",
    totalPaid: "አጠቃላይ ክፍያ",
    totalUnpaid: "አጠቃላይ ያልተከፈለ",
    unpaid: "ያልተከፈለ",
    paid: "የተከፈለ",
    statistics: "ተመን በመቶኛ",
    thisYearRevenue: "በዚህ ዓመት ገቢ",
    jan: "ጥር",
    feb: "የካቲት",
    mar: "መጋቢት",
    apr: "ሚያዝያ",
    may: "ግንቦት",
    jun: "ሰኔ",
    jul: "ሐምሌ",
    aug: "ነሐሴ",
    sep: "መስከረም",
    oct: "ጥቅምት",
    nov: "ሕዳር",
    dec: "ታህሳስ",

    //users
    no: "ቁጥር",
    newUsers: "አዳዲስ ተጠቃሚዎች",
    lockUser: "ተጠቃሚን ይዘምቱ",
    unlockUser: "ተጠቃሚን ክፈት",
    editUser: "ተጠቃሚን አርትዕ",
    usersPermissions: "የተጠቃሚ ፈቃዶች",
    addModule: "ሞጁል አክል",
    module: "ሞጁል",
    view: "እይታ",
    create: "ፍጠር",
    update: "አስተካክል",
    delete: "አስወግድ",
    addPermission: "ፈቃድ አክል",
    createdAt: "በተፈጠረበት ሰዓት",
    addUsers: "ተጠቃሚዎችን አክል",
    role: "ሚና",
    recordsPerPage:"መዝገቦች በገጽ",
    manager: "ማኔጅር",finance: "ፋይናንስ",user: "ተጠቃሚ", admin:"አስተዳዳሪ",
    selectTheAssociation:"ማህበሩን ይምረጡ",
    accountNumber:"የሂሳብ ቁጥር",

    //Association
    newAssociation: "አዲስ ማህበር",
    addAssociation: "ማህበር ያክሉ",
    addBulkData: "የጅምላ ውሂብ ያክሉ",
    associationName: "የማህበሩ ስም",
    associationType: "የማህበር አይነት",
    associationAmount: "የማህበሩ መጠን ገንዘብ",
    numberOfMembers: "የአባላት ብዛት",
    startDate: "የመጀመሪያ ቀን",
    endDate: "የመጨረሻ ቀን",
    cycle: "ዑደት",
    createdAt: "የተመዘገበበት ቀን",
    createdBy: "መዝጋቢው",
    description: "ማብራሪያ",
    downloadSampleFile: "ናሙና ፋይል አውርድ",
    uploadExcelFile: "የ ኤክሴል ፋይልን ይስቀሉ",
    browse: "ምስል ተመልከት",
    editAssociation: "ማሻሻያ ማህበር",
    associationOption:"ለማኅበር",
    individual:"ለግለሰብ",
    associationId:"የማህበሩ መለያ",
    adminUserName:"የአስተዳዳሪው ስም",

    Yearly: "ዓመታዊ",
    Monthly: "ወርሃዊ",
    Weakly: "ሳምንታዊ",
    Daily: "ዕለታዊ",

    //members
    newMember: "አዲስ አባል",
    addMember: "አባል ያክሉ",
    fullName: "ሙሉ ስም",
    email: "ኢሜል",
    sex: "ፆታ",
    phoneNumber: "ስልክ ቁጥር",
    address: "አድራሻ",
    job: "ሥራ",
    idNumber: "መታወቂያ ቁጥር",
    memberName: "የአባላት ስም",
    editMember:"አባልን ያስተካክሉ",
    associationLinkageDescription:"የማህበሩ ትስስር መግለጫ",
    memberDescription:"የአባላት መግለጫ",
    male: "ወንድ",
    female: "ሴት",

    Five: "አምስት",
    Four: "አራት",
    Three: "ሶስት",
    Two: "ሁለት",
    One: "አንድ",

    //Linking Association
    linkingAssociation: "አባል ወደ ማህበር ያክሉ",
    associationTypeInfo: "የማህበሩ አይነት መረጃ",
    associationMember: "የማህበር  አባል",
    associationLinkage: "የማህበሩ አባላት መጨመር",
    summary: "አጠቃላይ መረጃ",
    existingAssociationType: "ማኅበሩ አለ?",
    associationType: "የማህበር አይነት",
    associationName: "የማህበር ስም",
    associationAmount: "ማህበር የገንዘብ መጠን",
    cycle: "ዑደት",
    numberOfEkuber: "የማህበሩ አባላት ቁጥር",
    existingAssociationMember: "የማህበሩ አባል አለ?",
    associationMember: "የማህበር  አባል",
    numberOfShare: "የአባሉ መዋጮ ብዛት",
    totalAmount: "ጠቅላላ የገንዘብ መጠን",
    attachedDocument: "የተያያዘ ሰነድ",
    prev: "የቀድሞ",
    next: "ቀጣይ",
    editLinkage: "መረጃውን ያርትዑ",
    amount: "የገንዘብ መጠን",
    uniqueId: "ልዩ ቁጥር",
    nextPaymentDate: "የተከፈለበት ቀን/ቀጣይ የክፍያ ቀን",
    paymentStatus: "የክፍያ ሁኔታ",
    numberOfAssociationMembers: "የማህበሩ አባላት ቁጥር",
    linkageInformation: "የግንኙነት መረጃ",
    attachedFile: "የተያያዘ ፋይል",
    nothingFound: "ምንም አልተገኘም",

    // ክፍያ
    dateFrom: "ከቀን",
    dateTo: "እስከቀን",
    member: "አባል",
    memberPhoneNo: "የአባል ስልክ ቁጥር",
    paidAmount: "የተከፈለው ገንዘብ መጠን",
    paidFor: "ለዚህ ወር የተከፈለ",
    paidTypeFor: "የግብይት አይነት",
    paymentMethod: "የተከፈለበት ዘዴ",
    dateOfPayment: "የተከፈለበት ቀን",
    creditAccount: "የክሬዲት አካውንት",
    transactionReference: "የግብይት ማጣሪያ",
    noDateSelected: "ምንም ውሂብ አልተገኘም",
    find: "ፈልግ",
    status: "ሁኔታ",

    // ሪፖርት
    association: "ማህበር",
    paymentStatusForThisMonth: "የዚህ ወር የክፍያ ሁኔታ",
    completionStatus: "የማጠናቀቂያ ሁኔታ",
    contributionAmount: "መዋጮ መጠን",
    Drawn :"ዕቁብ ወስዷል?",
    totalMember: "ጠቅላላ አባል",
    totalCollectedAmount: "ጠቅላላ የተሰበሰበው መጠን (በብር)",
    totalServiceFee: "ጠቅላላ የአገልግሎት ክፍያ (በብር)",
    totalCollectedPayment: "ጠቅላላ የተሰበሰበ ክፍያ (በብር)",
    totalCollectedFeePayment: "ጠቅላላ የተሰበሰበ አገልግሎት ክፍያ (በብር)",
    memberPhone:"የአባላት ስልክ",
    savingStartDate:"የዕቁብ መጀመሪያ ቀን",
    exportToPdf:"ፒዲኤፍ ያውርዱ",
    exportToExcel:"ኤክሴል ያውርዱ",
    paymentId:"የዕቁብ መለያ ቁጥር",

    //Draw
    selectDrawFor:"የማሽከርከር ዓላማን ይምረጡ",
    numberOfEkub:"የመስጠት እድል ብዛት",
    selectAssociationType: "የማህበር አይነት ምረጥ",
    Spinning: "ያሽከርክሩ/ይስጡ",
    takerName:"የአሸናፊ ስም",
    nameOfAssociation:"የማህበር ስም",
    selectWinnerType:"የአሸናፊ አይነት ይምረጡ",
    associations:"ማህበራት",
    individuals:"ግለሰቦች",
    all:"ሁሉም",
    selectMethod:"ዘዴ ምረጥ",
    spin:"ያሽከርክሩ",
    manual:"ይስጡ",
    forAssociation:"ለማህበር",
    spinOrAssignFor:"እርምጃ ለ",
    selectAssociation:"ማህበር ይምረጡ",
    name:"ስም",
    uniqueId:"ልዩ ቁጥር",
    nameOrUniqueId:"ስም/ልዩ ቁጥር",
    enterTheAmount:"የገንዘቡን መጠን ያስገቡ",
    giveEqub:"ኢቁብ ስጠ",


    users: "ተጠቃሚዎች",
    association: "ማህበር",
    members: "አባላት",
    associationLinkage: "ማህበር ትስስር",
    drawingChance: "ዕጣ ማውጫ",
    paymentsHistory: "የክፍያ ታሪክ",
    report: "ሪፖርት"
  },
  oro: {
    //common
    areYouSureYouWantToSubmitThisForm: "Mirkaneeffachuu barbaadduu sirrii dha?",
    yes: "Eeyyee",
    nono: "Lakki",
    confirm: "Mirkaneessi",

    dashboard: 'Daashboorduu',
    unpaidList: 'Galii hin kaffalamne',
    language: 'Afaan',
    account: 'Akkaawuntii',
    logout: 'Ba’i',
    changePassword: 'Jecha iccitii jijjiiri',
    firstName: 'Maqaa jalqabaa',
    lastName: 'Maqaa abbaa',
    username: 'Maqaa fayyadamaa',
    phoneNumber: 'Lakkoofsa bilbila',
    email: 'Imeelii',
    oldPassword: 'Jecha iccitii durii',
    newPassword: 'Jecha iccitii haaraa',
    confirmPassword: 'Jecha iccitii mirkaneessi',
    submit: 'Ergaa',
    ServiceFee: 'Kaffaltii Tajaajilaa ',

    //overView
    allAssociation: 'Walitti dhufeenya hunda',
    allMembers: "Hirmaattoota hunda",
    thisMonth: "Ji’oota kana",
    thisMonthAndPassed: "Kanas darbee Ji'a",
    total:"Waliigala",
    totalPaid: "Galii waliigalaa",
    totalUnpaid: "Galii waliigalaa hin kaffalamne",
    unpaid: "Hin kaffalamne",
    paid: "Kaffalame",
    statistics: "Tasuma",
    thisYearRevenue: "Qarshii waggaa kanaa",
    jan: "Amajjii",
    feb: "Guraandhala",
    mar: "Bitootessa",
    apr: "Ebla",
    may: "Caamsaa",
    jun: "Waxabajjii",
    jul: "Adooleessa",
    aug: "Hagayya",
    sep: "Fuulbana",
    oct: "Onkololeessa",
    nov: "Sadaasa",
    dec: "Muddee",

    //users
    no: "Lakkoofsa",
    newUsers: "Fayyadamaa haaraa",
    lockUser: "Fayyadamaa cufi",
    unlockUser: "Fayyadamaa banu",
    editUser: "Fayyadamaa sirreessi",
    usersPermissions: "Hayyama fayyadamaa",
    addModule: "Moodhii dabalachiisi",
    module: "Moodhii",
    view: "Ilaali",
    create: "Uumu",
    update: "Haala sirreessi",
    delete: "Haquu",
    addPermission: "Hayyama dabalachiisi",
    createdAt: "Yeroo uumame",
    addUsers: "Fayyadamaa dabalachiisi",
    role: "Saayinsii",
    recordsPerPage:"Galmeen toora",
    manager: "Manaajara", finance: "Fiinansii", user: "Fayyadamaa", admin: "Admin",
    selectTheAssociation: "Walitti dhufeenya filadhu",
    accountNumber:"Lakkoofsa Herrega",

    //Association
    newAssociation: "Walitti dhufeenya haaraa",
    addAssociation: "Walitti dhufeenya dabalachiisi",
    addBulkData: "Daataa baay’ee dabalachiisi",
    associationName: "Maqaa walitti dhufeenyaa",
    associationType: "Gosa walitti dhufeenyaa",
    associationAmount: "Qarshii walitti dhufeenyaa",
    numberOfMembers: "Lakkoofsa hirmaattoota",
    startDate: "Guyyaa jalqabaa",
    endDate: "Guyyaa xumuraa",
    cycle: "Daandii",
    createdAt: "Guyyaa uumamaa",
    createdBy: "Kan uume",
    description: "Ibsa",
    downloadSampleFile: "Fayila sammii dhaabbadhu",
    uploadExcelFile: "Fayila Excelii dhaabbadhu",
    browse: "Fuula ilaali",
    editAssociation: "Walitti dhufeenya sirreessi",
    associationOption: "Walitti dhufeenya filadhu",
    individual: "Namoota",
    associationId: "ID walitti dhufeenyaa",
    adminUserName: "Maqaa adminii",

    Yearly: "Waggaa waggaa",
    Monthly: "Ji’a ji’a",
    Weakly: "Torbee torbee",
    Daily: "Guyyaa guyyaa",

    //members
    newMember: "Hirmaataa haaraa",
    addMember: "Hirmaataa dabalachiisi",
    fullName: "Maqaa guutuu",
    email: "Imeelii",
    sex: "Saala",
    phoneNumber: "Lakkoofsa bilbila",
    address: "Teessoo",
    job: "Hojii",
    idNumber: "Lakkoofsa ID",
    memberName: "Maqaa hirmaataa",
    editMember: "Hirmaataa sirreessi",
    associationLinkageDescription: "Ibsa walitti dhufeenyaa",
    memberDescription: "Ibsa hirmaattoota",
    male: "Dhiira",
    female: "Dhalaa",

    Five: "Shan",
    Four: "Afur",
    Three: "Sadi",
    Two: "Lama",
    One: "Tokko",

    //Linking Association
    linkingAssociation: "Hirmaataa walitti dhufeenyaa dabalachiisi",
    associationTypeInfo: "Odeeffannoo gosa walitti dhufeenyaa",
    associationMember: "Hirmaataa walitti dhufeenyaa",
    associationLinkage: "Hirmaattoota walitti dhufeenyaa dabalachiisi",
    summary: "Ibsa waliigalaa",
    existingAssociationType: "Walitti dhufeenyaa jiraa?",
    associationType: "Gosa walitti dhufeenyaa",
    associationName: "Maqaa walitti dhufeenyaa",
    associationAmount: "Qarshii walitti dhufeenyaa",
    cycle: "Daandii",
    numberOfEkuber: "Lakkoofsa hirmaattoota",
    existingAssociationMember: "Hirmaataa walitti dhufeenyaa jiraa?",
    associationMember: "Hirmaataa walitti dhufeenyaa",
    numberOfShare: "Lakkoofsa qooda",
    totalAmount: "Qarshii waliigalaa",
    attachedDocument: "Dokumantii dabalate",
    prev: "Dura",
    next: "Itaana",
    editLinkage: "Sirreessi",
    amount: "Qarshii",
    uniqueId: "ID adda",
    nextPaymentDate: "Guyyaa kaffaltii itaanaa",
    paymentStatus: "Haala kaffaltii",
    numberOfAssociationMembers: "Lakkoofsa hirmaattoota walitti dhufeenyaa",
    linkageInformation: "Odeeffannoo walitti dhufeenyaa",
    attachedFile: "Fayila dabalate",
    nothingFound: "Waan hin argamne",

    // Payment
    dateFrom: "Guyyaa irraa",
    dateTo: "Guyyaa hanga",
    member: "Hirmaataa",
    memberPhoneNo: "Lakkoofsa bilbila hirmaataa",
    paidAmount: "Qarshii kaffaltii",
    paidFor: "Ji’a kanaaf kaffaltii",
    paidTypeFor: "Gosa kaffaltii",
    paymentMethod: "Kaffaltii gochuu",
    dateOfPayment: "Guyyaa kaffaltii",
    creditAccount: "Akkaawuntii kireditii",
    transactionReference: "Mallattoo walqixxummaa",
    noDateSelected: "Guyyaa hin filatamne",
    find: "Barbaadi",
    status: "Haala",

    // Report
    association: "Walitti dhufeenya",
    paymentStatusForThisMonth: "Haala kaffaltii ji’a kanaa",
    completionStatus: "Haala xumuraa",
    contributionAmount: "Qarshii qooda",
    Drawn: "Fudhateera?",
    totalMember: "Hirmaattoota waliigalaa",
    totalCollectedAmount: "Qarshii waliigalaa (Birr)",
    totalServiceFee: "Kaffaltii waliigalaa (Birr)",
    totalCollectedPayment: "Kaffaltii waliigalaa (Birr)",
    totalCollectedFeePayment: "Kaffaltii waliigalaa (Birr)",
    memberPhone: "Lakkoofsa bilbila hirmaataa",
    savingStartDate: "Guyyaa jalqabaa",
    exportToPdf: "PDF dhaabbadhu",
    exportToExcel: "Excel dhaabbadhu",
    paymentId:"Lakkoofsa Kaffaltii",

    // Draw
    selectDrawFor: "Filadhu",
    numberOfEkub: "Lakkoofsa ekuubii",
    selectAssociationType: "Gosa walitti dhufeenyaa filadhu",
    Spinning: "Shaffeeffachuu",
    takerName: "Maqaa fudhattuu",
    nameOfAssociation: "Maqaa walitti dhufeenyaa",
    selectWinnerType: "Gosa fudhattuu filadhu",
    associations: "Walitti dhufeenyaa",
    individuals: "Namoota",
    all: "Hunda",
    selectMethod: "Filadhu",
    spin: "Shaffeeffachuu",
    manual: "Qajeelcha",
    forAssociation: "Walitti dhufeenyaaf",
    spinOrAssignFor: "Filadhu",
    selectAssociation:"Waldaa Filadhu",
    name:"Maqaa",
    uniqueId:"Lakkoofsa addaa",
    nameOrUniqueId:"Maqaa/Lakkoofsa addaa",
    enterTheAmount:"Hanga galchi",
    giveEqub:"Equb kennu",

    users: "Fayyadamaa",
    association: "Walitti dhufeenya",
    members: "Hirmaattoota",
    associationLinkage: "Walitti dhufeenyaa",
    drawingChance: "Fakkiin ekuubii",
    paymentsHistory: "Seenaa kaffaltii",
    report: "Ripoortii"
},
tg: {
  // ሓባራዊ
  areYouSureYouWantToSubmitThisForm: "እርግጠኛ ዲኻ/ዲኺ ነዚ ፎርም ክትህብዎ ደልኻ/ዲኺ?",
  yes: "እወ",
  nono: "ኣይፋል",
  confirm: "ኣረጋግጥ",

  dashboard: 'ዳሽቦርድ',
  unpaidList: 'ዘይተኸፍለ ዝርዝር',
  language: 'ቋንቋ',
  account: 'ኣካውንት',
  logout: 'ውጻእ',
  changePassword: 'ፓስዎርድ ቀይር',
  firstName: 'ስም',
  lastName: 'ዓባይ ስም',
  username: 'የተጠቃሚ ስም',
  phoneNumber: 'ቁጽሪ ስልኪ',
  email: 'ኢሜይል',
  oldPassword: 'ኣረጊት ፓስዎርድ',
  newPassword: 'ሓድሽ ፓስዎርድ',
  confirmPassword: 'ፓስዎርድ ኣረጋግጥ',
  submit: 'ኣስገባ',
  ServiceFee: 'ናይ ኣገልግሎት ክፍሊት ',

  // ኣጠቓላሊ ሓበሬታ
  allAssociation: 'ኩሎም ማሕበራት',
  allMembers: "ኩሎም ኣባላት",
  thisMonth: "ኣብዚ ወርሒ",
  thisMonthAndPassed: "እዚን ዝሓለፈ ወርሒ",
  total: "ጠቕላላ",
  totalPaid: "ጠቕላላ ክፍሊት",
  totalUnpaid: "ጠቕላላ ዘይተኸፍለ",
  unpaid: "ዘይተኸፍለ",
  paid: "ተኸፊሉ",
  statistics: "ቁጽሪ ብመወዳእታ",
  thisYearRevenue: "ኣብዚ ዓመት ገቢ",
  jan: "ጥሪ",
  feb: "ለካቲት",
  mar: "መጋቢት",
  apr: "ሚያዝያ",
  may: "ግንቦት",
  jun: "ሰነ",
  jul: "ሓምለ",
  aug: "ነሓሰ",
  sep: "መስከረም",
  oct: "ጥቅምቲ",
  nov: "ሕዳር",
  dec: "ታሕሳስ",

  // ተጠቃሚዎች
  no: "ቁጽሪ",
  newUsers: "ሓድሽ ተጠቃሚዎች",
  lockUser: "ተጠቃሚ ኣግድም",
  unlockUser: "ተጠቃሚ ክፈት",
  editUser: "ተጠቃሚ ኣርትዕ",
  usersPermissions: "የተጠቃሚ ፈቃድ",
  addModule: "ሞዱል ወስኽ",
  module: "ሞዱል",
  view: "ርአ",
  create: "ፍጠር",
  update: "ኣሻሽል",
  delete: "ሰርዝ",
  addPermission: "ፈቃድ ወስኽ",
  createdAt: "ኣብ ዝተፈጠረ ግዜ",
  addUsers: "ተጠቃሚዎች ወስኽ",
  role: "ሮል",
  recordsPerPage: "ዝርዝር ብገጽ",
  manager: "ማኔጅር", finance: "ፋይናንስ", user: "ተጠቃሚ", admin: "ኣድሚኒስትሬተር",
  selectTheAssociation: "ማሕበር ምረጥ",
  accountNumber:"ቁጽሪ ሂሳብ",

  // ማሕበር
  newAssociation: "ሓድሽ ማሕበር",
  addAssociation: "ማሕበር ወስኽ",
  addBulkData: "የጅምላ ውሂብ ወስኽ",
  associationName: "የማሕበር ስም",
  associationType: "የማሕበር ኣይነት",
  associationAmount: "የማሕበር ገንዘብ መጠን",
  numberOfMembers: "የኣባላት ቁጽሪ",
  startDate: "መጀመርታ ዕለት",
  endDate: "መወዳእታ ዕለት",
  cycle: "ዑደት",
  createdAt: "ዝተፈጠረ ዕለት",
  createdBy: "ዝፈጠሮ ሰብ",
  description: "መግለጺ",
  downloadSampleFile: "ናሙና ፋይል ማውርድ",
  uploadExcelFile: "ኤክሴል ፋይል ምቕራብ",
  browse: "ምስሊ ርአ",
  editAssociation: "ማሕበር ኣርትዕ",
  associationOption: "ለማሕበር",
  individual: "ለግለሰብ",
  associationId: "የማሕበር መታወቂያ",
  adminUserName: "የኣድሚኒስትሬተር ስም",

  Yearly: "ዓመታዊ",
  Monthly: "ወርሃዊ",
  Weakly: "ሳምንታዊ",
  Daily: "ዕለታዊ",

  // ኣባላት
  newMember: "ሓድሽ ኣባል",
  addMember: "ኣባል ወስኽ",
  fullName: "ምሉእ ስም",
  email: "ኢሜይል",
  sex: "ፆታ",
  phoneNumber: "ቁጽሪ ስልኪ",
  address: "ኣድራሻ",
  job: "ስራ",
  idNumber: "መታወቂያ ቁጽሪ",
  memberName: "የኣባል ስም",
  editMember: "ኣባል ኣርትዕ",
  associationLinkageDescription: "የማሕበር ትስስር መግለጺ",
  memberDescription: "የኣባላት መግለጺ",
  male: "ተባ",
  female: "ኣንስተይቲ",

  Five: "ሓሙሽተ",
  Four: "ኣርባዕተ",
  Three: "ሰለስተ",
  Two: "ክልተ",
  One: "ሓደ",

  // ማሕበር ትስስር
  linkingAssociation: "ኣባል ናብ ማሕበር ወስኽ",
  associationTypeInfo: "የማሕበር ኣይነት ሓበሬታ",
  associationMember: "የማሕበር ኣባል",
  associationLinkage: "የማሕበር ኣባላት ምውሳኽ",
  summary: "ኣጠቓላሊ ሓበሬታ",
  existingAssociationType: "ማሕበር ኣሎዶ?",
  associationType: "የማሕበር ኣይነት",
  associationName: "የማሕበር ስም",
  associationAmount: "የማሕበር ገንዘብ መጠን",
  cycle: "ዑደት",
  numberOfEkuber: "የማሕበር ኣባላት ቁጽሪ",
  existingAssociationMember: "የማሕበር ኣባል ኣሎዶ?",
  associationMember: "የማሕበር ኣባል",
  numberOfShare: "የኣባል መዋጮ ቁጽሪ",
  totalAmount: "ጠቕላላ ገንዘብ መጠን",
  attachedDocument: "ዝተያያዘ ሰነድ",
  prev: "ቅድሚ",
  next: "ቀጺሉ",
  editLinkage: "ሓበሬታ ኣርትዕ",
  amount: "ገንዘብ መጠን",
  uniqueId: "ልዩ ቁጽሪ",
  nextPaymentDate: "ቀጻሊ ክፍሊት ዕለት",
  paymentStatus: "የክፍሊት ሁኔታ",
  numberOfAssociationMembers: "የማሕበር ኣባላት ቁጽሪ",
  linkageInformation: "የትስስር ሓበሬታ",
  attachedFile: "ዝተያያዘ ፋይል",
  nothingFound: "ምንም ኣይተረኽበን",

  // ክፍሊት
  dateFrom: "ካብ ዕለት",
  dateTo: "ክሳዕ ዕለት",
  member: "ኣባል",
  memberPhoneNo: "የኣባል ስልኪ ቁጽሪ",
  paidAmount: "ዝከፈለ ገንዘብ መጠን",
  paidFor: "ኣብዚ ወርሒ ዝከፈለ",
  paidTypeFor: "የግብይት ኣይነት",
  paymentMethod: "የክፍሊት መወዳእታ",
  dateOfPayment: "የክፍሊት ዕለት",
  creditAccount: "ክሬዲት ኣካውንት",
  transactionReference: "የግብይት ማጣሪያ",
  noDateSelected: "ምንም ውሂብ ኣይተረኽበን",
  find: "ምድላይ",
  status: "ሁኔታ",

  // ሪፖርት
  association: "ማሕበር",
  paymentStatusForThisMonth: "የዚ ወርሒ የክፍሊት ሁኔታ",
  completionStatus: "የማጠናቀቂያ ሁኔታ",
  contributionAmount: "መዋጮ መጠን",
  Drawn: "ወሲዱዶ?",
  totalMember: "ጠቕላላ ኣባል",
  totalCollectedAmount: "ጠቕላላ ዝተኣከበ መጠን (ብር)",
  totalServiceFee: "ጠቕላላ የኣገልግሎት ክፍሊት (ብር)",
  totalCollectedPayment: "ጠቕላላ ዝተኣከበ ክፍሊት (ብር)",
  totalCollectedFeePayment: "ጠቕላላ ዝተኣከበ ኣገልግሎት ክፍሊት (ብር)",
  memberPhone: "የኣባል ስልኪ",
  savingStartDate: "የምዝገብ መጀመርታ ዕለት",
  exportToPdf: "ፒዲኤፍ ማውርድ",
  exportToExcel: "ኤክሴል ማውርድ",
  paymentId:"እቲ ናይ ክፍሊት ቁጽሪ",

  // ዕጣ
  selectDrawFor: "የዕጣ ዓላማ ምረጥ",
  numberOfEkub: "የምስጢር ቁጽሪ",
  selectAssociationType: "የማሕበር ኣይነት ምረጥ",
  Spinning: "ዕጣ ምልክት",
  takerName: "የዕጣ ተወሳኺ ስም",
  nameOfAssociation: "የማሕበር ስም",
  selectWinnerType: "የዕጣ ተወሳኺ ኣይነት ምረጥ",
  associations: "ማሕበራት",
  individuals: "ግለሰቦች",
  all: "ኩሎም",
  selectMethod: "ዘዴ ምረጥ",
  spin: "ዕጣ ምልክት",
  manual: "ኢድ ምልክት",
  forAssociation: "ለማሕበር",
  spinOrAssignFor: "እርምጃ ለ",
  selectAssociation:"ማሕበር ምረጹ",
  name:"ሽም",
  uniqueId:"ፍሉይ ቁጽሪ",
  nameOrUniqueId:"ሽም/ፍሉይ ቁጽሪ",
  enterTheAmount:"መጠን ገንዘብ ኣእትዉ",
  giveEqub:"ኢቁብ ስጥ",

  users: "ተጠቃሚዎች",
  association: "ማሕበር",
  members: "ኣባላት",
  associationLinkage: "ማሕበር ትስስር",
  drawingChance: "ዕጣ ማውጫ",
  paymentsHistory: "የክፍሊት ታሪኽ",
  report: "ሪፖርት"
}
};
